import { Proposal } from "@/models/proposal.model";
import { FormValues } from "@/models/proposalForm.model";

export function mergeFormDataWithProposal(formData: FormValues): Proposal {
  return {
    ...formData.proposal,
    anticipatedYears:
      formData.resultStep.antecipatedYears ??
      formData.proposal?.anticipatedYears,
    chosenFinancialInfoId:
      formData.resultStep.chosenFinancialOption?.id ??
      formData.proposal?.chosenFinancialInfoId,
    chosenFinancialInfo:
      formData.resultStep.chosenFinancialOption ??
      formData.proposal?.chosenFinancialInfo,
    NaturalPerson: {
      ...formData.proposal?.NaturalPerson,
      name:
        formData.personalData.name ?? formData.proposal?.NaturalPerson?.name,
      birthDate:
        formData.personalData.birthDate ??
        formData.proposal?.NaturalPerson?.birthDate,
      phoneNumber:
        formData.personalData.cellphone ??
        formData.proposal?.NaturalPerson?.phoneNumber,
      motherName:
        formData.personalData.motherName ??
        formData.proposal?.NaturalPerson?.motherName,
      updatedAt: new Date().toISOString(),
      address: {
        ...formData.proposal?.NaturalPerson?.address,
        addressName:
          formData.address.street ??
          formData.proposal?.NaturalPerson?.address?.addressName,
        number:
          formData.address.streetNumber !== undefined
            ? String(formData.address.streetNumber)
            : formData.proposal?.NaturalPerson?.address?.number,
        zipCode:
          formData.address.cep ??
          formData.proposal?.NaturalPerson?.address?.zipCode,
        district:
          formData.address.district ??
          formData.proposal?.NaturalPerson?.address?.district,
        complement:
          formData.address.complement ??
          formData.proposal?.NaturalPerson?.address?.complement,
        city:
          formData.address.city ??
          formData.proposal?.NaturalPerson?.address?.city,
        uf:
          formData.address.state ??
          formData.proposal?.NaturalPerson?.address?.uf,
      },
    },
    BankDetail: {
      ...formData.proposal?.BankDetail,
      pixKeyType:
        formData.bankData.pixType ?? formData.proposal?.BankDetail?.pixKeyType,
      pixKey: formData.bankData.pixKey ?? formData.proposal?.BankDetail?.pixKey,
      account:
        formData.bankData.account !== undefined
          ? formData.bankData.account
          : formData.proposal?.BankDetail?.account,
      agency: formData.bankData.agency ?? formData.proposal?.BankDetail?.agency,
      accountDigit:
        formData.bankData.digit ?? formData.proposal?.BankDetail?.accountDigit,
      bankCode:
        formData.bankData.bankCode ?? formData.proposal?.BankDetail?.bankCode,
    },
  };
}
